<template>
  <section class="forum-box">
    <div class="forum">
      <div class="forum-info" v-if="mainForum.zones">
        <div class="forum-title">
            <strong class="slidetop" data-scroll data-scroll-call="animateMove">
              {{mainForum.title}}<vue-typed-js :strings="[mainForum.time]" :loop="true"
                :startDelay="300"
                :typeSpeed="100"
                :backSpeed="50">
                <time class="typing"></time>
              </vue-typed-js>
            </strong>
            <!-- <time>{{mainForum.zones[0].the_date | timeFormat('mm.dd')}}</time> -->
            <small data-scroll data-scroll-speed="-1" data-scroll-direction="horizontal">{{mainForum.title_en}}</small>
        </div>
        <div class="tribune slidetop" data-scroll data-scroll-call="animateMove" @mousemove="chageMove($event)" @mouseout="hiddenMove1($event)" @mouseover="showMove1($event,mainForum.zones[0].cover)">
          <router-link :to="{ path: `/2022/agendaview/${mainForum.zones[0].id}`}">
            <div class="tribune-info">
              <p>{{mainForum.zones[0].description}}</p>
            </div>
            <i class="tribune-arrow">
              <svg class="show" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4061.14 292.41"><defs></defs><g id="图层_2" data-name="图层 2"><g id="Capa_1" data-name="Capa 1"><polygon class="cls-1" points="3914.93 0 3887.46 27.43 3986.82 126.8 0 126.8 0 165.62 3986.82 165.62 3887.44 264.92 3914.94 292.41 4061.14 146.21 3914.93 0"/></g></g></svg>
              <svg class="hide" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1896.5 292.41"><defs></defs><g id="图层_2" data-name="图层 2"><g id="Capa_1" data-name="Capa 1"><polygon class="cls-1" points="1750.29 0 1722.82 27.43 1822.18 126.8 0 126.8 0 165.62 1822.18 165.62 1722.8 264.92 1750.3 292.41 1896.5 146.21 1750.29 0"/></g></g></svg>
            </i>
          </router-link>
         
        </div>
      </div>
       <div class="icon-imgs" :class="{'is-play':mouseShowfirst}" :style="{ left: scrollX, top: scrolltop }"><img :src="mainForum.zones[0].cover" alt=""/></div>
      <div class="forum-list">
        <div class="forum-item" v-for="(item, index2) in forumData" :key="item.title_en">
          <div class="forum-title slidetop" data-scroll data-scroll-call="animateMove">
            <strong>
              {{item.title}}<vue-typed-js :strings="[item.time]" :loop="true"
                :startDelay="0"
                :typeSpeed="100"
                :backSpeed="50">
                <time class="typing"></time>
              </vue-typed-js>
            </strong>
            <small data-scroll data-scroll-speed="-1" data-scroll-direction="horizontal">{{item.title_en}}</small>
          </div>
          <ul class="form-list">
            <li class="slidetop" data-scroll data-scroll-call="animateMove" v-for="(item1) in item.zones" :key="item1.id" @mousemove="chageMove($event)" @mouseout="hiddenMove($event)" @mouseover="showMove($event,item1.cover)">
              <router-link :to="{ path: `/2022/agendaview/${item1.id}`, query: { b: index2 + 1}}">
                <img :src="item1.cover" alt=""/>
                <strong>{{item1.title}}</strong>
                <p>{{item1.description}}</p>
                <time>{{item1.start_time}} - {{item1.end_time}}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1896.5 292.41"><defs></defs><g id="图层_2" data-name="图层 2"><g id="Capa_1" data-name="Capa 1"><polygon class="cls-1" points="1750.29 0 1722.82 27.43 1822.18 126.8 0 126.8 0 165.62 1822.18 165.62 1722.8 264.92 1750.3 292.41 1896.5 146.21 1750.29 0"/></g></g></svg></time>
              </router-link>
            </li>
          </ul>
          <div class="icon-imgs" :class="{'is-play':mouseShow}" :style="{ left: scrollX, top: scrolltop }"><img :src="forumImg" alt=""/></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      scrollX: 0,
      scrollY: 0,
      scrolltop: 0,
      mouseShowfirst: false,
      mouseShow: false,
      forumData: [],
      mainForum: {},
      forumImg: require("@/assets/images/mouse.png")
    }
  },
  props: {
    scroll: Object
  },
  methods: {
    async getForum () {
      const { data: res } = await this.$http.get('/zones')
      if (res.code === 1) {
        const resData = res.data
        this.mainForum = resData[0]
        this.forumData = resData
        this.forumData.splice(0, 1)
        this.forumData[1] = this.forumData.splice(0, 1, this.forumData[1])[0]
        setTimeout(() => {
          this.scroll.update()
        }, 400)
        this.$set(this.mainForum, 'time', this.$filter.timeFormat(this.mainForum.zones[0].the_date, 'mm.dd'))
        this.forumData.forEach((item, index) => {
          this.$set(item, 'time', this.$filter.timeFormat(item.zones[0].the_date, 'mm.dd'))
        })
        console.log(this.forumData)
        // this.$set(this.forumData[0].zones[4], 'iconImg', require('@/assets/images/场景实践.png'))
        // this.$set(this.forumData[0].zones[3], 'iconImg', require('@/assets/images/RTE-Cloud.png'))
        // this.$set(this.forumData[0].zones[2], 'iconImg', require('@/assets/images/开源技术.png'))
        // this.$set(this.forumData[0].zones[0], 'iconImg', require('@/assets/images/音频技术.png'))
        // this.$set(this.forumData[0].zones[1], 'iconImg', require('@/assets/images/视频技术.png'))

        // this.$set(this.forumData[1].zones[0], 'iconImg', require('@/assets/images/产品论坛.png'))
        // this.$set(this.forumData[1].zones[1], 'iconImg', require('@/assets/images/教育.png'))
        // this.$set(this.forumData[1].zones[2], 'iconImg', require('@/assets/images/数字化.png'))
        // this.$set(this.forumData[1].zones[3], 'iconImg', require('@/assets/images/IoT.png'))
        // this.$set(this.forumData[1].zones[4], 'iconImg', require('@/assets/images/泛娱乐.png'))

        // this.$set(this.forumData[2].zones[0], 'iconImg', require('@/assets/images/大赛.png'))
        // this.$set(this.forumData[2].zones[1], 'iconImg', require('@/assets/images/生态论坛.png'))
      }
    },
    chageMove (e) {
      this.scrollX = e.clientX + 'px'
      this.scrolltop = (e.clientY + this.scrollY) + 'px'
    },
    showMove (e, iconimgs) {
      this.mouseShow = true
      this.forumImg = iconimgs
    },
    hiddenMove () {
      this.mouseShow = false
    },
     showMove1 () {
      this.mouseShowfirst = true
    },
    hiddenMove1 () {
      this.mouseShowfirst = false
    },
    scrollBac () {
      setTimeout(() => {
        this.scroll.on('scroll', (args) => {
          this.scrollY = Math.round(args.scroll.y)
        })
      })
    }
  },
  mounted () {
    this.getForum()
    this.scrollBac()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/home/index.less");
</style>
